import React ,{useState,useEffect}from 'react';
import { ChevronDown } from "lucide-react";
import './Topbar.css';
import Logo from "../images/Logo.png"
import {
  Facebook,
  Twitter,
  Instagram,
  Linkedin
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [animate, setAnimate] = useState(false);
  
  const location = useLocation()
  const scrollNow =()=>{
    window.scrollTo({
      top:0,
      behavior:'smooth'
    })
  }

  useEffect(()=>{
  scrollNow()
  },[location])


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
        setAnimate(true); // trigger animation
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav  className={`Topnavbar ${scrolled ? 'scrolled' : ''}`}><Link to="/" >
      <div className="navbar-logo">
        <div className="logo-1sttext">
          <img src={Logo} style={{height:'70px'}}/>        </div>
        <span className="logo-text">Global</span>
      </div></Link>
      
      <ul className="navbar-links">
      <li><Link to="/" style={{color:"black"}}>Home</Link></li>
      <li><Link to="/about" style={{color:"black"}}>About Us</Link></li>

        <li className="dropdown-parent" style={{color:"black"}}>
          Trading <ChevronDown size={16} />
          <ul className="dropdown">
            <li><Link to="/domestic-trading" style={{color:"black"}}>Domestic Trading</Link></li>
            <li><Link to="/international-trading" style={{color:"black"}}>International Trading</Link></li>
          </ul>
        </li>

        <li className="dropdown-parent" style={{color:"black"}}>
          Product <ChevronDown size={16} />
          <ul className="dropdown" style={{color:"black"}}>
            <li><Link to="/products/alloy-metal-scrap" style={{color:"black"}}>Alloy Metal Scrap</Link></li>
            <li><Link to="/products/non-alloy-metal-scrap" style={{color:"black"}}>Non-Alloy Metal Scrap</Link></li>
            <li><Link to="/products/ferrous-metal" style={{color:"black"}}>Ferrous Metal</Link></li>
            <li><Link to="/products/non-ferrous-metal" style={{color:"black"}}>Non-Ferrous Metal</Link></li>
            <li><Link to="/products/specialty-mixed-scrap" style={{color:"black"}}>Specialty & Mixed Scrap</Link></li>
            <li><Link to="/products/agro-products-export" style={{color:"black"}}>Agro Products Export</Link></li>
            <li><Link to="/products/agriculture-commodities" style={{color:"black"}}>Agriculture Commodities</Link></li>
            <li><Link to="/products/medical-equipment" style={{color:"black"}}>Medical Equipment</Link></li>
          </ul>
        </li>

        

        
 
      </ul>

      <div className="RightSide">
        <div>
        <Link to="/contact" style={{color:"white"}}>Contact Us</Link>
      

        </div>
      </div>
    </nav>
  );
}

export default Navbar;
